/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_Option_EndInputs */



/**
* | output |
* | --- |
* | "End Time" |
*
* @param {Compare_Event_Groups_Option_EndInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_option_end = /** @type {((inputs?: Compare_Event_Groups_Option_EndInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_Option_EndInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fin des temps")
	if (locale === "de") return /** @type {LocalizedString} */ ("Endzeit")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ora di fine")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Конец времени")
	if (locale === "es") return /** @type {LocalizedString} */ ("Fin de los tiempos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("结束时间")
	if (locale === "ja") return /** @type {LocalizedString} */ ("終了時刻")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अंत समय")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Hora final")
	return /** @type {LocalizedString} */ ("End Time")
});